const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Dots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "100 100 400 100",
    width: 400,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgba(0, 0, 0, 0)",
      fill: "rgb(0, 133, 125)"
    },
    cx: 150,
    cy: 150,
    rx: 50,
    ry: 50
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgba(0, 0, 0, 0)",
      fill: "rgb(0, 133, 125)"
    },
    cx: 299.054,
    cy: 150,
    rx: 50,
    ry: 50
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgba(0, 0, 0, 0)",
      fill: "rgb(0, 133, 125)"
    },
    cx: 450,
    cy: 150,
    rx: 50,
    ry: 50
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dots);
export default __webpack_public_path__ + "static/media/3dots.2e13cfde22c4141ae7013081cdb517e9.svg";
export { ForwardRef as ReactComponent };